import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { COUNTRIES } from "@/lib/countries";
import { useLang } from "@/context/LanguageContext";

// Full world-country picker: searchable, flags, and a real vertical scrollbar
// to browse progressively through all countries.
export function CountrySelect({ value, onChange, testid = "country-select" }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const sel = COUNTRIES.find((c) => c.code === value);
  const norm = (x) => x.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  const list = COUNTRIES.filter((c) => norm(c.name).includes(norm(q.trim())));
  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid={testid}
        className="w-full h-11 rounded-xl border border-input bg-background px-3 flex items-center justify-between text-sm">
        <span className="truncate">{sel ? `${sel.flag} ${sel.name}` : t("hc.chooseACountry")}</span>
        <ChevronDown size={16} className="opacity-60 shrink-0" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 mt-1 w-full rounded-xl border border-border bg-white shadow-xl overflow-hidden">
            <div className="p-2 border-b border-border">
              <input autoFocus value={q} onChange={(e) => setQ(e.target.value)}
                placeholder={t("hc.searchForACountry")} data-testid="country-search"
                className="w-full h-9 rounded-lg border border-input px-2 text-sm outline-none focus:ring-2 focus:ring-findo-indigo/30" />
            </div>
            <ul className="max-h-64 overflow-y-auto py-1" data-testid="country-list">
              {list.map((c) => (
                <li key={c.code}>
                  <button type="button" onClick={() => { onChange(c.code); setOpen(false); setQ(""); }}
                    data-testid={`country-opt-${c.code}`}
                    className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-100 flex items-center gap-2 ${c.code === value ? "bg-findo-indigo/10 text-findo-indigo font-semibold" : ""}`}>
                    <span>{c.flag}</span><span className="flex-1 truncate">{c.name}</span>
                    <span className="text-xs text-slate-400">+{c.dial}</span>
                  </button>
                </li>
              ))}
              {list.length === 0 && <li className="px-3 py-4 text-sm text-slate-400 text-center">{t("hc.noCountryFound")}</li>}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
